module.exports = __webpack_public_path__ + "img/Rewind_white.dba2cae9.png";